/* ============================================================
   BT · Product hero — gedrag
   Losse asset zodat het sectiebestand klein blijft.
   Instellingen komen uit <script type="application/json" data-bt-hero-config>

   Kleur en maat zitten in de bundelkaarten zelf: de gekozen staffel klapt
   open met één regel per stuk. De keuzes zijn gedeeld op rij-index, dus
   wisselen van staffel behoudt wat al gekozen is.
   ============================================================ */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.btReady) return;
    root.dataset.btReady = '1';

    var cfgEl = root.querySelector('[data-bt-hero-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = {}; }
    var variants = cfg.variants || [];
    var optionCount = (cfg.optionNames || []).length || 1;

    function money(cents) {
      try {
        return new Intl.NumberFormat(cfg.locale || 'en', {
          style: 'currency', currency: cfg.currency || 'EUR'
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    /* ---------------- galerij ---------------- */
    var gal = root.querySelector('[data-bt-gallery]');
    var showSlide = null;
    if (gal) {
      var slides = gal.querySelectorAll('[data-bt-slide]');
      var thumbs = gal.querySelectorAll('[data-bt-thumb]');
      var dots   = gal.querySelectorAll('[data-bt-dots] i');
      var i = 0;

      var show = function (n) {
        if (!slides.length) return;
        i = (n + slides.length) % slides.length;
        for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('is-active', k === i);
        for (var t = 0; t < thumbs.length; t++) thumbs[t].classList.toggle('is-active', t === i);
        for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      };
      showSlide = show;

      Array.prototype.forEach.call(thumbs, function (t) {
        t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-bt-thumb'), 10)); });
      });
      var pv = gal.querySelector('[data-bt-prev]'), nx = gal.querySelector('[data-bt-next]');
      if (pv) pv.addEventListener('click', function () { show(i - 1); });
      if (nx) nx.addEventListener('click', function () { show(i + 1); });

      var main = gal.querySelector('.bt-gal__main');
      if (main) {
        var x0 = null, y0 = null;
        main.addEventListener('touchstart', function (e) {
          x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY;
        }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(dx < 0 ? i + 1 : i - 1);
          x0 = y0 = null;
        }, { passive: true });
      }
    }

    /* ---------------- aantalteller ---------------- */
    var qtyInput = root.querySelector('[data-bt-qty-input]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-bt-qty]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-bt-qty'), 10) || 0;
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      });
    });

    /* ---------------- gedeelde elementen ---------------- */
    var form    = root.querySelector('[data-bt-form]');
    var vInput  = root.querySelector('[data-bt-variant-input]');
    var priceEl = root.querySelector('[data-bt-price]');
    var atc     = root.querySelector('[data-bt-atc]');
    var errEl   = root.querySelector('[data-bt-picker-error]');
    var dynamic = root.querySelector('[data-bt-dynamic]');
    var hasPicker = !!root.querySelector('[data-bt-pk-row]');

    function toNumber(v) {
      if (!v) return NaN;
      var t = String(v).replace(/[^0-9.,]/g, '');
      if (!t) return NaN;
      var dec = Math.max(t.lastIndexOf(','), t.lastIndexOf('.'));
      var tail = t.length - dec - 1;
      if (dec > -1 && tail > 0 && tail <= 2) {
        t = t.slice(0, dec).replace(/[.,]/g, '') + '.' + t.slice(dec + 1);
      } else {
        t = t.replace(/[.,]/g, '');
      }
      var n = parseFloat(t);
      return isFinite(n) ? n : NaN;
    }

    function setPriceRow(price, compare, unit) {
      var was  = root.querySelector('[data-bt-compare]');
      var save = root.querySelector('[data-bt-save]');
      var un   = root.querySelector('[data-bt-unit]');
      if (priceEl && price) priceEl.textContent = price;

      var p = toNumber(price), c = toNumber(compare);
      var vis = !!compare && isFinite(p) && isFinite(c) && c > p;

      if (was) { was.textContent = vis ? compare : ''; was.hidden = !vis; }
      if (save) {
        if (vis) { save.textContent = '-' + Math.round((c - p) / c * 100) + '%'; save.hidden = false; }
        else save.hidden = true;
      }
      if (un) { un.textContent = unit || ''; un.hidden = !unit; }
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    /* ============================================================
       Kleur- en maatkeuze
       ============================================================ */
    var colorIndex = typeof cfg.colorIndex === 'number' ? cfg.colorIndex : -1;
    var itemCount  = 1;
    var choices    = [];   /* gedeeld op rij-index over alle kaarten */

    function rowsFor(idx) {
      return root.querySelectorAll('[data-bt-pk-row][data-bt-item="' + idx + '"]');
    }
    function allRows() {
      return root.querySelectorAll('[data-bt-pk-row]');
    }
    function maxIndex() {
      var m = 0;
      Array.prototype.forEach.call(allRows(), function (r) {
        var n = parseInt(r.getAttribute('data-bt-item'), 10) || 0;
        if (n > m) m = n;
      });
      return m;
    }

    function findVariant(opts) {
      if (!opts) return null;
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < optionCount; o++) {
          if (opts[o] == null || variants[v].options[o] !== opts[o]) { ok = false; break; }
        }
        if (ok) return variants[v];
      }
      return null;
    }

    function comboAvailable(partial) {
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var o = 0; o < optionCount; o++) {
          if (partial[o] != null && variants[v].options[o] !== partial[o]) { ok = false; break; }
        }
        if (ok && variants[v].available) return true;
      }
      return false;
    }

    function paintRow(row, idx) {
      var opts = choices[idx] || [];
      Array.prototype.forEach.call(row.querySelectorAll('[data-bt-swatch],[data-bt-size]'), function (btn) {
        var oi  = parseInt(btn.getAttribute('data-bt-opt-index'), 10);
        var val = btn.getAttribute('data-bt-value');

        var on = opts[oi] != null && opts[oi] === val;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');

        var probe = opts.slice();
        probe[oi] = val;
        var can = comboAvailable(probe);
        btn.classList.toggle('is-soldout', !can);
        btn.disabled = !can;
      });

      /* "Kleur: Zwart" — de gekozen waarde in de labelregel */
      Array.prototype.forEach.call(row.querySelectorAll('[data-bt-opt-label]'), function (el) {
        var oi = parseInt(el.getAttribute('data-bt-opt-label'), 10);
        el.textContent = opts[oi] != null ? opts[oi] : '';
      });
    }

    function refreshItem(idx) {
      Array.prototype.forEach.call(rowsFor(idx), function (row) { paintRow(row, idx); });
    }

    function refreshAll() {
      for (var idx = 0; idx <= maxIndex(); idx++) refreshItem(idx);
    }

    function isComplete(idx) {
      var opts = choices[idx];
      if (!opts) return false;
      for (var o = 0; o < optionCount; o++) if (opts[o] == null) return false;
      return true;
    }

    /* ---- staffelprijzen laten meebewegen met de gekozen variant ----
       De kaarten krijgen hun bedragen van de server, gerekend met de variant
       die bij het laden in de URL stond. Zodra varianten onderling in prijs
       verschillen (het aantal verwarmingszones) klopt dat na een wissel niet
       meer, dus rekenen we dezelfde som na als in bt-opt-card.liquid, met
       dezelfde afronding naar beneden per stuk. */
    function fieldIn(card, sel, make, before) {
      var el = card.querySelector(sel);
      if (!el) {
        el = make();
        var wrap = card.querySelector('.bt-opt-card__price');
        if (!wrap) return null;
        var ref = before ? card.querySelector(before) : null;
        if (ref) wrap.insertBefore(el, ref); else wrap.appendChild(el);
      }
      return el;
    }

    function setField(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.style.display = text ? '' : 'none';
    }

    /* de variant van rij idx; nog niet ingevulde rijen volgen stuk 1, precies
       zoals setItemCount ze straks ook invult */
    function rowVariant(idx, fallback) {
      var v = (choices[idx] && isComplete(idx)) ? findVariant(choices[idx]) : null;
      return v || fallback;
    }

    function recalcTiers(variant) {
      if (!variant) return;

      Array.prototype.forEach.call(root.querySelectorAll('[data-bt-opt]'), function (card) {
        if (card.hasAttribute('data-bt-bundle')) return;   /* de bundel rekent zelf */
        var pct = parseInt(card.getAttribute('data-pct'), 10);
        if (!isFinite(pct)) return;                        /* vaste teksten uit het blok laten staan */

        var qty = parseInt(card.dataset.qty, 10) || 1;

        /* elk stuk is een eigen regel in de winkelwagen en mag een eigen
           variant hebben, dus tellen we de stukken op in plaats van de prijs
           van stuk 1 te vermenigvuldigen. Korting per stuk naar beneden
           afgerond, net als Shopify in de checkout. */
        var lineAfter = 0, refTotal = 0, firstUnit = null, sameUnit = true;
        for (var i = 0; i < qty; i++) {
          var rv = rowVariant(i, variant);
          var rp = rv.price;
          var ru = rp - Math.floor(rp * pct / 100);
          lineAfter += ru;
          refTotal  += (rv.compare_at_price && rv.compare_at_price > rp) ? rv.compare_at_price : rp;
          if (firstUnit === null) firstUnit = ru;
          else if (ru !== firstUnit) sameUnit = false;
        }

        var priceTxt   = money(lineAfter);
        /* "per stuk" alleen tonen als de stukken ook echt evenveel kosten */
        var unitTxt    = sameUnit ? money(firstUnit) + ' ' + (cfg.perPiece || '') : '';
        var compareTxt = '';
        var flagTxt    = '';
        if (refTotal > lineAfter) {
          compareTxt = money(refTotal);
          var save = refTotal - lineAfter;
          var savePct = Math.floor((Math.floor(save * 200 / refTotal) + 1) / 2);
          flagTxt = (cfg.saveText || '').replace('__PCT__', savePct);
        }

        card.dataset.price   = priceTxt;
        card.dataset.unit    = unitTxt;
        card.dataset.compare = compareTxt;

        setField(card.querySelector('[data-bt-c-price]'), priceTxt);
        setField(fieldIn(card, '[data-bt-c-compare]', function () {
          var s = document.createElement('s'); s.setAttribute('data-bt-c-compare', ''); return s;
        }, '[data-bt-c-unit]'), compareTxt);
        setField(fieldIn(card, '[data-bt-c-unit]', function () {
          var s = document.createElement('span');
          s.className = 'bt-opt-card__unit'; s.setAttribute('data-bt-c-unit', ''); return s;
        }, null), unitTxt);

        var flag = card.querySelector('[data-bt-c-flag]');
        if (!flag && flagTxt) {
          flag = document.createElement('span');
          flag.className = 'bt-opt-card__flag';
          flag.setAttribute('data-bt-c-flag', '');
          card.appendChild(flag);
        }
        setField(flag, flagTxt);
      });
    }

    /* de prijsregel en de sticky balk volgen de kaart die aanstaat */
    function syncActiveCardPrice() {
      var card = root.querySelector('[data-bt-opt].is-active');
      if (!card || card.hasAttribute('data-bt-bundle')) return;
      setPriceRow(card.dataset.price, card.dataset.compare, card.dataset.unit);
      var sp = document.querySelector('[data-bt-sticky-price]');
      if (sp && card.dataset.price) sp.textContent = card.dataset.price;
    }

    /* Geen staffelkaarten in de koopmodule? Dan komt de prijs rechtstreeks
       van de gekozen variant. Met kaarten blijft syncActiveCardPrice leidend. */
    function syncVariantPrice(match) {
      if (!match || root.querySelector('[data-bt-opt]')) return;
      var compare = match.compare_at_price > match.price ? money(match.compare_at_price) : '';
      setPriceRow(money(match.price), compare, '');
      var sp = document.querySelector('[data-bt-sticky-price]');
      if (sp) sp.textContent = money(match.price);
    }

    /* Eerste stuk stuurt de galerij en het verborgen id-veld aan. */
    function syncPrimary() {
      var match = findVariant(choices[0] || []);
      if (match && vInput) vInput.value = match.id;

      recalcTiers(match);
      syncActiveCardPrice();
      syncVariantPrice(match);

      if (atc && !atc.classList.contains('is-loading')) {
        var soldout = match && match.available === false;
        atc.disabled = !!soldout;
        atc.textContent = soldout ? (cfg.soldoutText || 'Sold out') : (cfg.atcText || 'Add to basket');
      }

      if (match && history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    function onPick(idx, optIndex, value, mediaIndex) {
      if (!choices[idx]) choices[idx] = new Array(optionCount).fill(null);
      choices[idx][optIndex] = value;

      /* een maat die niet meer kan bij deze kleur laten vallen */
      for (var o = 0; o < optionCount; o++) {
        if (o === optIndex || choices[idx][o] == null) continue;
        if (!comboAvailable(choices[idx].slice())) choices[idx][o] = null;
      }

      refreshItem(idx);
      Array.prototype.forEach.call(rowsFor(idx), function (r) { r.classList.remove('is-missing'); });
      showError('');

      if (idx === 0) {
        if (optIndex === colorIndex && showSlide && mediaIndex >= 0 && cfg.mediaCount > mediaIndex) {
          showSlide(mediaIndex);
        }
        syncPrimary();
        syncBundlePrice();
      } else {
        /* stuk 2 of verder telt mee in de staffelprijs */
        recalcTiers(findVariant(choices[0] || []));
        syncActiveCardPrice();
      }
    }

    if (hasPicker) {
      /* beginstand uit de gerenderde knoppen lezen */
      for (var s = 0; s <= maxIndex(); s++) choices[s] = new Array(optionCount).fill(null);
      var firstRow = root.querySelector('[data-bt-pk-row][data-bt-item="0"]');
      if (firstRow) {
        Array.prototype.forEach.call(firstRow.querySelectorAll('.is-active[data-bt-swatch],.is-active[data-bt-size]'), function (btn) {
          choices[0][parseInt(btn.getAttribute('data-bt-opt-index'), 10)] = btn.getAttribute('data-bt-value');
        });
      }
      refreshAll();
      syncPrimary();
    }

    /* ---------------- koopmodule ---------------- */
    var buy = root.querySelector('[data-bt-buy]');
    var planInput = null;

    /* ---------------- bundel ----------------
       Elke bundeloptie = het huidige product + één product uit het
       bundelblok (met eigen kleur- en maatkeuze). Er is altijd maar één
       optie gekozen, dus nooit meer dan één extra product. */
    var bundle = null;          /* { code, pct, products: [{ id, options, variants }] } */
    var bundleActive = false;
    var bundleChoices = [];
    var bundleCards = root.querySelectorAll('[data-bt-bundle]');
    var bundleCard = null;      /* de gekozen bundeloptie */
    var bundleIndex = -1;       /* index van het gekozen extra product */
    var bundleEl = root.querySelector('[data-bt-bundle-data]');
    if (bundleEl && bundleCards.length) {
      try { bundle = JSON.parse(bundleEl.textContent); } catch (e) { bundle = null; }
    }
    if (bundle && bundle.products) {
      bundle.products.forEach(function (bp) { bundleChoices.push(new Array(bp.options.length).fill(null)); });
    } else {
      bundle = null;
    }

    function matchIn(list, opts, partial) {
      for (var v = 0; v < list.length; v++) {
        var ok = true;
        for (var o = 0; o < opts.length; o++) {
          if (opts[o] == null) { if (partial) continue; ok = false; break; }
          if (list[v].options[o] !== opts[o]) { ok = false; break; }
        }
        if (ok && (!partial || list[v].available)) return list[v];
      }
      return null;
    }
    function bundleVariant(pi) { return matchIn(bundle.products[pi].variants, bundleChoices[pi], false); }
    function bundleRow(pi) { return root.querySelector('[data-bt-b-row][data-bt-b="' + pi + '"]'); }

    function paintBundleRow(pi) {
      var row = bundleRow(pi);
      if (!row) return;
      var opts = bundleChoices[pi];
      Array.prototype.forEach.call(row.querySelectorAll('[data-bt-b-opt]'), function (btn) {
        var oi  = parseInt(btn.getAttribute('data-bt-opt-index'), 10);
        var val = btn.getAttribute('data-bt-value');
        var on = opts[oi] === val;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var probe = opts.slice();
        probe[oi] = val;
        var can = !!matchIn(bundle.products[pi].variants, probe, true);
        btn.classList.toggle('is-soldout', !can);
        btn.disabled = !can;
      });
    }

    /* lege keuzes vullen: één mogelijke waarde, anders de keuze van stuk 1 (op optienaam) */
    function seedBundle() {
      var names = cfg.optionNames || [];
      bundle.products.forEach(function (bp, pi) {
        var opts = bundleChoices[pi];
        bp.options.forEach(function (name, oi) {
          if (opts[oi] != null) return;
          var values = [];
          bp.variants.forEach(function (v) { if (values.indexOf(v.options[oi]) < 0) values.push(v.options[oi]); });
          if (values.length === 1) { opts[oi] = values[0]; return; }
          var mi = names.indexOf(name);
          var mine = mi > -1 && choices[0] ? choices[0][mi] : null;
          if (mine != null && values.indexOf(mine) > -1) {
            opts[oi] = mine;
            if (!matchIn(bp.variants, opts, true)) opts[oi] = null;
          }
        });
        paintBundleRow(pi);
      });
    }

    /* bundelprijs volgt de gekozen varianten; zolang die gelijk is aan de
       gerenderde prijs blijft de Liquid-opmaak staan */
    function updateBundlePrice() {
      if (!bundle) return;
      var main = findVariant(choices[0] || []);
      if (!main && vInput) {
        for (var v = 0; v < variants.length; v++) if (String(variants[v].id) === String(vInput.value)) main = variants[v];
      }
      if (!main) return;
      Array.prototype.forEach.call(bundleCards, function (card) {
        var pi = parseInt(card.getAttribute('data-bt-b'), 10);
        var bp = bundle.products[pi];
        if (!bp) return;
        var bv = bundleVariant(pi) || matchIn(bp.variants, [], true) || bp.variants[0];
        var total = main.price + bv.price;
        if (total === parseInt(card.getAttribute('data-total'), 10)) return;
        card.setAttribute('data-total', total);
        /* korting per product naar beneden afgerond, zoals Shopify in de checkout */
        var pct = bundle.pct || 0;
        var after = total - Math.floor(main.price * pct / 100) - Math.floor(bv.price * pct / 100);
        card.dataset.price = money(after);
        card.dataset.compare = money(total);
        var pe = card.querySelector('[data-bt-b-price]');
        var ce = card.querySelector('[data-bt-b-compare]');
        if (pe) pe.textContent = card.dataset.price;
        if (ce) ce.textContent = card.dataset.compare;
      });
    }

    function syncBundlePrice() {
      if (!bundleActive) return;
      updateBundlePrice();
      setPriceRow(bundleCard.dataset.price, bundleCard.dataset.compare, bundleCard.dataset.unit);
      var sp = document.querySelector('[data-bt-sticky-price]');
      if (sp) sp.textContent = bundleCard.dataset.price;
    }

    function onBundlePick(pi, optIndex, value) {
      var opts = bundleChoices[pi];
      opts[optIndex] = value;
      for (var o = 0; o < opts.length; o++) {
        if (o === optIndex || opts[o] == null) continue;
        if (!matchIn(bundle.products[pi].variants, opts, true)) opts[o] = null;
      }
      paintBundleRow(pi);
      var row = bundleRow(pi);
      if (row) row.classList.remove('is-missing');
      showError('');
      syncBundlePrice();
    }

    /* zet de bundelcode op de winkelwagen, bestaande codes blijven staan */
    function applyBundleCode(rootUrl) {
      var code = bundle && bundle.code;
      if (!code) return Promise.resolve();
      return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var has = codes.some(function (c) { return String(c).toUpperCase() === code.toUpperCase(); });
          if (has) return null;
          codes.push(code);
          return fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .catch(function () { /* de producten staan in de winkelwagen; de code kan nog handmatig */ });
    }

    function setItemCount(n) {
      itemCount = Math.max(1, parseInt(n, 10) || 1);
      /* nieuwe stukken beginnen met de keuze van stuk 1 en blijven daarna los */
      for (var idx = 1; idx < itemCount; idx++) {
        var empty = !choices[idx] || choices[idx].every(function (x) { return x == null; });
        if (empty) choices[idx] = (choices[0] || []).slice();
      }
      refreshAll();
      recalcTiers(findVariant(choices[0] || []));
      /* de snelle betaalknoppen kunnen maar één variant meenemen */
      if (dynamic) dynamic.style.display = itemCount > 1 ? 'none' : '';
      showError('');
    }

    if (buy) {
      planInput = buy.querySelector('[data-bt-plan-input]');
      var qtyBox = root.querySelector('.bt-qty');
      if (qtyBox && buy.querySelectorAll('[data-bt-opt]').length) qtyBox.style.display = 'none';

      var applyOption = function (card) {
        var panel = card.closest('[data-bt-panel]');
        if (panel) {
          Array.prototype.forEach.call(panel.querySelectorAll('[data-bt-opt]'), function (c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-checked', 'false');
          });
        }
        card.classList.add('is-active');
        card.setAttribute('aria-checked', 'true');
        var radio = card.querySelector('input[type=radio]');
        if (radio) radio.checked = true;

        if (qtyInput && card.dataset.qty) qtyInput.value = card.dataset.qty;
        setItemCount(card.dataset.qty || 1);

        bundleActive = !!bundle && card.hasAttribute('data-bt-bundle');
        bundleCard = bundleActive ? card : null;
        bundleIndex = bundleActive ? parseInt(card.getAttribute('data-bt-b'), 10) : -1;
        if (bundleActive) { seedBundle(); updateBundlePrice(); }
        if (dynamic) dynamic.style.display = (itemCount > 1 || bundleActive) ? 'none' : '';

        var plan = card.dataset.plan || '';
        if (planInput) { planInput.value = plan; planInput.disabled = !plan; }

        setPriceRow(card.dataset.price, card.dataset.compare, card.dataset.unit);
        var sp2 = document.querySelector('[data-bt-sticky-price]');
        if (sp2 && card.dataset.price) sp2.textContent = card.dataset.price;
      };

      Array.prototype.forEach.call(buy.querySelectorAll('[data-bt-opt]'), function (card) {
        card.addEventListener('click', function (ev) {
          /* klikken op een swatch of maat mag de staffel niet omzetten */
          if (ev.target.closest('[data-bt-expand]')) return;
          applyOption(card);
        });
        card.addEventListener('keydown', function (ev) {
          if (ev.target !== card) return;
          if (ev.key === ' ' || ev.key === 'Enter' || ev.key === 'Spacebar') {
            ev.preventDefault();
            applyOption(card);
          }
        });
      });

      /* kleur- en maatknoppen, gedelegeerd vanaf de koopmodule */
      buy.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-bt-swatch],[data-bt-size]');
        if (!btn || btn.disabled) return;
        var row = btn.closest('[data-bt-pk-row]');
        if (!row) return;
        ev.preventDefault();
        ev.stopPropagation();
        onPick(
          parseInt(row.getAttribute('data-bt-item'), 10),
          parseInt(btn.getAttribute('data-bt-opt-index'), 10),
          btn.getAttribute('data-bt-value'),
          parseInt(btn.getAttribute('data-bt-media'), 10)
        );
      });

      /* kleur- en maatknoppen van de bundelproducten */
      buy.addEventListener('click', function (ev) {
        var btn = ev.target.closest('[data-bt-b-opt]');
        if (!btn || btn.disabled || !bundle) return;
        var row = btn.closest('[data-bt-b-row]');
        if (!row) return;
        ev.preventDefault();
        ev.stopPropagation();
        onBundlePick(
          parseInt(row.getAttribute('data-bt-b'), 10),
          parseInt(btn.getAttribute('data-bt-opt-index'), 10),
          btn.getAttribute('data-bt-value')
        );
      });

      Array.prototype.forEach.call(buy.querySelectorAll('[data-bt-mode]'), function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-bt-mode');
          Array.prototype.forEach.call(buy.querySelectorAll('[data-bt-mode]'), function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          Array.prototype.forEach.call(buy.querySelectorAll('[data-bt-panel]'), function (pnl) {
            pnl.classList.toggle('is-active', pnl.getAttribute('data-bt-panel') === mode);
          });
          var next = buy.querySelector('[data-bt-panel].is-active [data-bt-opt].is-active')
                  || buy.querySelector('[data-bt-panel].is-active [data-bt-opt]');
          if (next) applyOption(next);
        });
      });

      var first = buy.querySelector('[data-bt-panel].is-active [data-bt-opt].is-active')
               || buy.querySelector('[data-bt-panel].is-active [data-bt-opt]');
      if (first) applyOption(first);
    } else {
      setItemCount(1);
    }

    /* ============================================================
       Toevoegen aan winkelwagen — meerdere regels in één keer
       ============================================================ */
    function buildLines() {
      var lines = [];
      var plan = planInput && !planInput.disabled ? planInput.value : '';

      if (!hasPicker && vInput) lines.push({ id: parseInt(vInput.value, 10), quantity: 1 });
      for (var idx = 0; hasPicker && idx < itemCount; idx++) {
        if (!isComplete(idx)) return { error: cfg.errIncomplete, at: idx };
        var v = findVariant(choices[idx]);
        if (!v || v.available === false) return { error: cfg.errUnavailable, at: idx };

        var existing = null;
        for (var l = 0; l < lines.length; l++) if (lines[l].id === v.id) existing = lines[l];
        if (existing) existing.quantity += 1;
        else {
          var line = { id: v.id, quantity: 1 };
          if (plan) line.selling_plan = plan;
          lines.push(line);
        }
      }

      /* bundel: alleen het gekozen extra product, één stuk */
      if (bundleActive && bundle.products[bundleIndex]) {
        var bv = bundleVariant(bundleIndex);
        if (!bv) return { error: cfg.errIncomplete, bundleAt: bundleIndex };
        if (bv.available === false) return { error: cfg.errUnavailable, bundleAt: bundleIndex };
        lines.push({ id: bv.id, quantity: 1 });
      }

      /* aangevinkte producten uit "Maak je set compleet" gaan mee in dezelfde
         toevoeging; de sectie staat buiten de hero, vandaar document-breed */
      Array.prototype.forEach.call(document.querySelectorAll('[data-bt-set-item].is-on'), function (el) {
        var sid = parseInt(el.getAttribute('data-bt-variant'), 10);
        if (!sid) return;
        var hit = null;
        for (var l = 0; l < lines.length; l++) if (lines[l].id === sid) hit = lines[l];
        if (hit) hit.quantity += 1;
        else lines.push({ id: sid, quantity: 1 });
      });

      return { lines: lines };
    }

    function openCartDrawer() {
      var toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) { toggle.click(); return true; }
      return false;
    }

    function setBusy(on) {
      if (!atc) return;
      atc.classList.toggle('is-loading', on);
      atc.disabled = on;
      if (on) {
        atc.dataset.btLabel = atc.textContent;
        atc.textContent = cfg.addingText || '…';
      } else if (atc.dataset.btLabel) {
        atc.textContent = atc.dataset.btLabel;
        delete atc.dataset.btLabel;
      }
    }

    if (form) {
      form.addEventListener('submit', function (ev) {
        if (!hasPicker && !bundleActive && !document.querySelector('[data-bt-set-item].is-on')) return;   /* geen keuzes: laat de gewone post staan */
        ev.preventDefault();
        ev.stopPropagation();

        var built = buildLines();
        if (built.error) {
          showError(built.error);
          var rows = built.bundleAt != null ? [bundleRow(built.bundleAt)] : rowsFor(built.at);
          Array.prototype.forEach.call(rows, function (r) {
            if (r.closest('.bt-opt-card.is-active')) {
              r.classList.add('is-missing');
              r.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
          return;
        }

        showError('');
        setBusy(true);

        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: built.lines })
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data && (data.description || data.message) || '');
            return data;
          });
        }).then(function () {
          /* bundel: kortingscode op de winkelwagen zetten */
          return bundleActive ? applyBundleCode(rootUrl) : null;
        }).then(function () {
          setBusy(false);
          document.dispatchEvent(new CustomEvent('bt:cart:added', { detail: { items: built.lines } }));
          if (!openCartDrawer()) window.location.href = rootUrl + 'cart';
        }).catch(function (err) {
          setBusy(false);
          showError((err && err.message) || cfg.errGeneric);
        });
      });
    }

    /* ---------------- sticky koopbalk ---------------- */
    var sticky = document.querySelector('[data-bt-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.classList.add('bt-has-sticky');
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(atc);

      var sbtn = sticky.querySelector('[data-bt-sticky-atc]');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (!form) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bt-hero]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
